"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const roadmapSteps = [{
  id: "1",
  numeral: "01",
  title: "Audit",
  description: "Comprehensive analysis of your current website performance, technical health, and local SEO standing."
}, {
  id: "2",
  numeral: "02",
  title: "Strategy",
  description: "Developing a customized, revenue-driven plan targeting high-value keywords specific to your business."
}, {
  id: "3",
  numeral: "03",
  title: "Implementation",
  description: "Executing on-page optimizations, technical fixes, and off-page strategies to build authority."
}, {
  id: "4",
  numeral: "04",
  title: "Reporting",
  description: "Transparent, ongoing tracking of rankings, traffic growth, and lead generation metrics."
}];
export default function SeoSuccessRoadmap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="seo-success-roadmap" className="py-24 bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-4xl font-bold font-sans text-primary mb-4">
            SEO Success Roadmap
          </h2>
          <p className="text-lg text-foreground max-w-2xl mx-auto" style={{
          fontFamily: 'Helvetica, Arial, sans-serif'
        }}>
            Our proven four-step process designed to increase your visibility, drive targeted traffic, and generate more revenue.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-[2px] bg-border z-0" />
          
          {}
          <div className="md:hidden absolute top-12 bottom-12 left-[3.25rem] w-[2px] bg-border z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10">
            {roadmapSteps.map((step, i) => <div key={step.id} data-index={i} className="flex flex-row md:flex-col items-start md:items-center gap-6 md:gap-8">
                {}
                <div className="shrink-0 w-24 md:w-auto flex justify-center bg-background py-2 md:py-0 md:px-4">
                  <span className="text-6xl md:text-7xl font-black text-transparent tracking-tighter" style={{
                WebkitTextStroke: '2px var(--color-primary)'
              }}>
                    {step.numeral}
                  </span>
                </div>
                
                {}
                <div className="pt-4 md:pt-0 md:text-center flex-1">
                  <h3 className="text-2xl font-bold font-sans text-primary mb-3">
                    {step.title}
                  </h3>
                  <p className="text-base text-foreground leading-relaxed" style={{
                fontFamily: 'Helvetica, Arial, sans-serif'
              }}>
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-20 text-center">
          <Button asChild size="lg" className="bg-accent text-primary hover:bg-accent/90 font-bold px-8 py-6 text-lg shadow-md transition-colors duration-200">
            <Link to="/ContactPage">
              Schedule a Consultation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}